module.exports = __webpack_public_path__ + "static/media/Board_Before.5d4a2641.jpg";